//Định nghĩa tham số cố định

export const DOMAIN = "https://elearning0706.cybersoft.edu.vn";
export const TOKEN = "accessToken";
export const GROUPID = "GP05";
export const CATE_BACKEND = "BackEnd";
export const CATE_DESIGN = "Design";
export const CATE_DIDONG = "DiDong";
export const CATE_FRONTEND = "FrontEnd";
export const CATE_FULLSTACK = "FullStack";
export const CATE_TUDUY = "TuDuy";

export const USER_SIGNIN = "USER_SIGNIN";
